module.exports = __webpack_public_path__ + "media/cyclone1.0742a897.webm";